
import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';
import { useResponsive } from '@/hooks/use-mobile';

interface FormContainerProps {
  children: ReactNode;
  className?: string;
}

const FormContainer: React.FC<FormContainerProps> = ({ children, className = '' }) => {
  const { isMobile, isTablet, screenSize } = useResponsive();
  
  // Apply different padding and styling based on screen size
  const containerClasses = isMobile 
    ? 'px-1.5'
    : isTablet 
      ? 'px-3'
      : 'px-0 md:px-2';
  
  const cardClasses = isMobile 
    ? 'p-2.5'
    : isTablet 
      ? 'p-4'
      : 'p-3 md:p-5';

  return (
    <div className={`container mx-auto ${containerClasses} max-w-5xl ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className={`bg-white rounded-xl shadow-lg ${cardClasses} border border-amber-100 card-cheerful relative z-10`}
      >
        {/* Debug indicator - only visible in development */}
        {process.env.NODE_ENV === 'development' && (
          <div className="hidden md:block text-xs text-gray-400 mb-2 text-right">
            Current size: {screenSize}
          </div>
        )}
        {children}
      </motion.div>
    </div>
  );
};

export default FormContainer;
